import React from 'react';
import SimpleHouseholdContext from 'Context/SimpleHouseholdContext';

export function useMaybeSimpleHousehold() {
  return React.useContext(SimpleHouseholdContext);
}

export default function useSimpleHousehold() {
  const context = React.useContext(SimpleHouseholdContext);

  if (context === undefined) {
    throw new Error(
      'useSimpleHouseholdContext must be used within a SimpleHouseholdProvider',
    );
  }

  return context;
}
